import {
  SET_QUEUE_VISIBILITY,
  SET_PAGE_TITLE,
  SET_PAGE_STATUS,
  ADD_PAGE_ERROR,
  SET_PAGE_ERROR_CODE,
  CLEAR_PAGE_ERRORS,
  SET_GENRES_LIST_STATE
} from "@/store/mutation-types";

export default {
  [SET_QUEUE_VISIBILITY](state, flag) {
    state.queue = flag;
  },
  [SET_GENRES_LIST_STATE](state, newState) {
    state.genresList = { ...state.genresList, ...newState };
  },
  [SET_PAGE_TITLE](state, title) {
    state.title = title;
  },
  [SET_PAGE_STATUS](state, status) {
    state.status = status;
  },
  [SET_PAGE_ERROR_CODE](state, code) {
    state.errorCode = code;
  },
  [ADD_PAGE_ERROR](state, error) {
    state.errors = [...state.errors, error];
  },
  [CLEAR_PAGE_ERRORS](state) {
    state.errors = [];
  }
};
